/*
 * Copyright (c) 2010, 2023 BSI Business Systems Integration AG
 *
 * This program and the accompanying materials are made
 * available under the terms of the Eclipse Public License 2.0
 * which is available at https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 */
import {Event, EventMap, KeyStroke, KeyStrokeContext, KeyStrokeManager} from '../index';

export interface KeyStrokeManagerKeyStrokeEvent<T = KeyStrokeManager> extends Event<T> {
  keyStroke: KeyStroke;
  keyStrokeContext: KeyStrokeContext;
}

export interface KeyStrokeManagerEventMap extends EventMap {
  'keyStroke': KeyStrokeManagerKeyStrokeEvent;
}
